export default __webpack_public_path__ + "static/media/value-integrity.19e69e48.svg";